import React, {useEffect} from 'react';
import './Blog.css';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Blog() {
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Blog Page' });
  });
  return (
  <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Blog</title>
      </Helmet>
    <div className="blog-post container">
      <h1 className="blog-title">A Journey of Transformation: <span style={{color: 'green'}}>How Joining a Strong Mangrove
          Planting Community in Indonesia Changed My Life</span></h1>
      <h4 className="blog-subtitle" style={{color: '#2c7fab'}}>Blog of a volunteer in a program in Indonesia</h4>
      {/* Intro Paragraph */}
      <p className="blog-intro">In the lush coastal regions of Indonesia, where turquoise waters meet emerald forests, I
        found myself at a crossroads in life, yearning for a deeper purpose. Little did I know that fate would lead
        me to a transformative journey of hope, empowerment, and environmental stewardship, all through joining a
        strong community dedicated to planting mangrove trees. In this blog, I will share my personal experience and
        how this community's collective efforts not only revitalized the coastal ecosystem but also brought
        transformation to my feeling of purpose and life.</p>
      {/* Image or Divider */}
      <div className="blog-image">
        <img src="/img/img/indonesia.jpg" className='' alt="Indonesian Coastline" />
      </div>
      {/* Main Blog Content */}
      <div className="blog-content">
        <p>My journey began with an invitation from a friend to join a mangrove planting event in a coastal village
          in Indonesia. Intrigued by the prospect of making a positive impact, I set off to meet a diverse group
          of individuals who shared the common goal of restoring and preserving the coastal ecosystem through
          mangrove reforestation.</p>
        <p>From the moment I stepped into the heart of the village, I was embraced by the warmth and unity of the
          community. Their passion for the environment and determination to safeguard their natural heritage was
          infectious. I quickly realized that being part of this movement was more than just planting trees; it
          was about cultivating a sense of belonging and camaraderie that transcended language and cultural
          barriers.
        </p>
        {/* More paragraphs as needed */}
      </div>
      {/* Conclusion */}
      <div className="blog-conclusion">
        <p>As we planted mangrove saplings side by side, I felt a profound connection to the earth and the life it
          sustains. The simple act of planting a tree symbolized hope and regeneration. Each planted mangrove seed
          represented a promise to future generations – a testament to our collective efforts to combat climate
          change and protect fragile coastal ecosystems.
          Through workshops and interactive sessions, the community emphasized the importance of conservation
          education. They taught us about the vital role mangroves play in carbon sequestration, erosion control,
          and providing habitat for marine life. Armed with this knowledge, we became advocates for environmental
          awareness within our own communities and beyond.</p>
      </div>
      <div className="blog-content">
        <p>As our mangrove forest grew and flourished, so did the sense of purpose and determination within the
          community. The positive change we witnessed was not limited to the environment alone. Economic
          opportunities flourished as eco-tourism initiatives were introduced, bringing in visitors eager to
          experience the beauty of the restored mangroves.</p>
        <p>In the process of contributing to the community's cause, I experienced profound personal growth and
          resilience. The challenges faced during the planting process, such as braving the elements and adapting
          to new surroundings, taught me valuable life lessons about perseverance and humility.
        </p>
        {/* More paragraphs as needed */}
      </div>
      <div className="blog-content">
        <p>Joining the strong mangrove planting community in Indonesia was an experience that shaped my life.
          Witnessing the transformation of a once-degraded coastal area into a thriving mangrove ecosystem filled
          my heart with hope for the future. It is a testament to the power of community, collaboration, and
          shared passion for environmental conservation.</p>
        <p>As I reflect on my journey, I am grateful for the opportunity to be part of something larger than myself
          – a movement that not only revitalized nature but also transformed my perspective on life's purpose.
          Through the humble act of planting mangrove trees, I found a profound connection to the earth and an
          unwavering commitment to protect our planet for generations to come.
        </p>
        {/* More paragraphs as needed */}
      </div>
    </div>
    {/* Back to Top */}
    <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></a>

  </div>

  );
}

export default Blog;